import React from "react";
import { Box, Button, Typography, Card, CardContent } from "@mui/material";

const CustomCard = ({ card_id, title, description, img, onButtonClick }) => {
  return (
    <Card
      sx={{
        // width: "300px",
        // height: "400px",
        width: { xl: "520px", xs: "300px" },
        height: { xl: "560px", xs: "400px" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        padding: "16px",
        textAlign: "center",
        transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for animation
        "&:hover": {
          transform: "translateY(-8px) scale(1.03)", // Moves 8px upward and grows slightly
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)", // Stronger shadow on hover
        },
      }}
    >
      {/* Image Section */}
      <Box
        component="img"
        src={img} // Dynamically load image
        alt={title}
        sx={{
          // width: "100px",
          // height: "100px",
          width: {xl: "240px", xs: "100px"},
          height: {xl: "240px", xs: "100px"},
          borderRadius: "50%",
          marginTop: "16px",
        }}
      />

      {/* Content Section */}
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", marginBottom: "8px" }}
        >
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "#555" }}>
          {description}
        </Typography>
      </CardContent>

      {/* Button Section */}
      <Button
        variant="outlined"
        sx={{
          marginBottom: "16px",
          textTransform: "none",
          backgroundColor: "white", // add this line
          color: "#4c3bea",
          borderColor: "#4c3bea",
          "&:hover": {
            backgroundColor: "#4c3bea",
            color: "white",
            borderColor: "#4c3bea",
          },
        }}
        onClick={() => onButtonClick(card_id)} // Call parent handler with card_id
      >
        Explore WhatsApp Use Cases
      </Button>
    </Card>
  );
};

export default CustomCard;
